import {initProductMainSwipers} from '@/app/js/swiper/product/product-main'
import {initProductRelatedSwiper} from '@/app/js/swiper/product/product-related'
import {initProductPyramidSwiper} from '@/app/js/swiper/product/product-pyramids'
import {initProductReviewsSwiper} from '@/app/js/swiper/product/product-reviews'

export function initProductSwipers() {
  initProductMainSwipers()
  initProductRelatedSwiper()
  initProductPyramidSwiper()
  initProductReviewsSwiper()
}
